import React, { FC } from 'react';
import Select from 'react-select';
import { Col, Label } from 'reactstrap';

interface Option {
    value: string;
    label: string;
}

interface Field {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    label?: string;
    value: string;
    mandatory?: boolean;
    disabled?: boolean;
    isMulti?: boolean;
    isClearable?: boolean;
    options?: Option[];
    placeholder?: string;
    typeKey?: string;
    disableRemove?: boolean;
    keys?: boolean;
    className?:string;
}

interface Validation {
    handleBlur: (event: React.FocusEvent<HTMLInputElement> | any) => void;
    handleChange: (event: React.ChangeEvent<HTMLInputElement> | any) => void;
    touched: { [key: string]: boolean };
    errors: { [key: string]: string };
    values: { [key: string]: any };
}

interface SelectComponentProps {
    field: Field;
    labelCss?: string;
    mode?: string;
    validation: Validation;
    onChange?: (event: React.ChangeEvent<HTMLInputElement> | any) => void;
    customOnChange?: (event: React.ChangeEvent<HTMLInputElement> | any) => void;
}

const SelectComponent: FC<SelectComponentProps> = (props) => {
    return (
        <Col xs={props.field?.xs} sm={props.field?.sm} md={props.field?.md} lg={props.field?.lg} xl={props.field?.xl}>
            <div className="mt-2">
                {props.field?.label ? (
                    <Label htmlFor={props.field?.value} className={`form-label m-0 mb-1 ${props.labelCss && props.labelCss}`}>
                        {props.field.label}
                        {props.mode !== 'view' && <span className="text-danger ps-1"> {props.field.mandatory ? '*' : ''}</span>}
                        {props.mode === 'view' && <span className="ps-1"> :</span>}
                    </Label>
                ) : (
                    <Label></Label>
                )}
                {props.mode !== 'view' ? (
                    <Select
                    
                      styles={{
                        singleValue: (styles: any) => ({
                            ...styles,
                            color: '#0c0c0cff', 
                        }),
                        multiValueLabel: (styles: any) => ({
                            ...styles,
                            color: '#080808ff', 
                        }),
                    }}
                        classNamePrefix="custom-select"
                        // styles={{
                        //     control: (styles: any, state: { selectProps: { isDisabled: any } }) => ({
                        //         ...styles,
                        //         backgroundColor: state.selectProps.isDisabled ? '#f2f2f2' : 'white'
                        //     }),
                        //     menu: (styles: any) => ({
                        //         ...styles,
                        //         backgroundColor: 'white',
                        //         zIndex: 999999,
                        //         lineBreak: 'anywhere',
                        //         cursor: 'pointer'
                        //     }),
                        //     option: (styles: any, { isSelected, isFocused }: any) => ({
                        //         ...styles,
                        //         backgroundColor: isSelected ? '#048c71' : isFocused ? '#9dc9bd' : 'white',
                        //         color: isSelected ? 'white' : '#000000',
                        //         cursor: 'pointer'
                        //     })
                        // }}
                        
                        getOptionValue={(option: { value: any }) => option.value}
                        getOptionLabel={(option: { label: any }) => option.label}
                        autoFocus={false}
                        isDisabled={props.field?.disabled}
                        isMulti={props.field.isMulti ? true : false}
                        isClearable={props.field.isClearable ? true : false}
                        id={props.field.label}
                        name={props.field.value}
                        options={props.field.options}
                        placeholder={`${'Select'} ${props.field?.placeholder}`}
                        onBlur={() => props.validation.handleBlur({ target: { name: props.field.value } })}
                        onChange={(selectedOption: any) => {
                            // If "Select All" is chosen in a multi-select, replace it with all real options
                            let resolvedOption = selectedOption;
                            if (
                                props.field.isMulti &&
                                Array.isArray(selectedOption) &&
                                selectedOption.some((o: any) => o?.value === '__select_all__')
                            ) {
                                resolvedOption = (props.field.options || []).filter((o: any) => o?.value !== '__select_all__');
                            }

                            if (props.customOnChange) {
                                props?.customOnChange({
                                    target: {
                                        name: props.field.value,
                                        value: resolvedOption,
                                        isMulti: props.field.isMulti,
                                        typeKey: props.field.typeKey
                                    }
                                });
                            }
                            if (props?.onChange) {
                                props?.onChange({
                                    target: {
                                        name: props.field.value,
                                        value: resolvedOption,
                                        keys: props.field.keys ? resolvedOption : undefined
                                    }
                                });
                            }
                            props.validation.handleChange({ target: { name: props.field.value, value: resolvedOption } });
                        }}
                        value={props.validation?.values[props.field.value] || ''}
                        isSearchable={true}
                        noOptionsMessage={() => 'No data found'}
                      className={`text-dark ${
    props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value]
        ? 'border-danger border-rounded-2'
        : ''
}`}

                        components={props.field?.disableRemove ? { MultiValueRemove: () => null } : {}}
                    />
                ) : (
                    <span className="ps-1">
                        {props.validation?.values?.[props.field.value]?.length > 0
                            ? props.validation?.values?.[props.field.value]
                                  ?.map((v: { label: any }) => v.label)
                                  ?.toString()
                                  ?.split(',')
                                  ?.join(', ')
                            : props.validation?.values[props.field.value]?.label
                            ? props.validation?.values[props.field.value]?.label
                            : props.validation?.values[props.field.value] && props.validation?.values[props.field.value]?.length > 0
                            ? props.validation?.values[props.field.value]
                            : '–'}
                    </span>
                )}
                {props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value] ? (
                    <p className="text-danger fs-12 pt-1">{props.validation.errors[props.field?.value]}</p>
                ) : null}
            </div>
        </Col>
    );
};

export default SelectComponent;
